import Vue from "vue";
import Router from "vue-router";
import Top from "@/screens/Top";
import Scout from "@/screens/Scout";

Vue.use(Router);

const routes = [
  {
    path: "/",
    component: Top
  },
  {
    path: "/scout",
    component: Scout
  }
];

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js